
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import * as Utils from '@Cyclope-Utils/index';
import {ExportCameraCSVLoadedActionFail, ExportCameraCSVLoadedActionInProgress, ExportCameraCSVLoadedActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';


/**
 * @function ExportCameraCSVLoadedActionCreator
 * @return {Promise<any>}  Promise
 */
export function ExportCameraCSVLoadedActionCreator(): (
    dispatch: Dispatch<any>, {}) => Promise<any> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ExportCameraCSVLoadedActionInProgress());

        await Utils.exportCameraAllCsv()
        .then((response: any)=> {
      if (response.ok) {
        /**
         * @constant
         * @name contentHeader
         * @type string
         */
        const contentHeader: string = response.headers.get('content-type');

        { /* Comparer les valeurs */
        }
        if (contentHeader && contentHeader !== null &&
            contentHeader.indexOf('text/plain') !== -1) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat en JSON  */
            }

            response.blob().then((data: any) => {
              dispatch(ExportCameraCSVLoadedActionSuccess(data));
              const file = new Blob([data], {type: 'text/csv;charset=utf-8;'});
              const urlz = window.URL.createObjectURL(file);
              const Link = document.createElement('a');
              Link.href = urlz;
              Link.download = 'export-camera.csv';

              document.body.appendChild(Link);
              Link.click();
              Link.remove();
            });  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.json().then(
                (text: any) => dispatch(ExportCameraCSVLoadedActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
        if (contentHeader === null || contentHeader === undefined) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.blob().then((data: any) => {
              dispatch(ExportCameraCSVLoadedActionSuccess(data));
              const file = new Blob([data], {type: 'text/csv;charset=utf-8;'});
              const urlz = window.URL.createObjectURL(file);
              const Link = document.createElement('a');
              Link.href = urlz;
              Link.download = 'export-camera.csv';

              document.body.appendChild(Link);
              Link.click();
              Link.remove();
            })  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(ExportCameraCSVLoadedActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
      } else {
        throw ({
          message: response.statusText,
          status: response.status,
          url: response.url,
          headers: response.headers
        });
      }}).catch( (error: any) => {
                dispatch(ExportCameraCSVLoadedActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                Utils.fetchLogs(error.url,error.message,error.status,error.headers)
            })
  }
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/actions/camera/export-csv/index.ts